import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  createColumn,
  createViewAction,
  formatDate,
  numberFormat,
} from "../../utils/helpers";
import { URL_CONFIGURABLES } from "../../utils/urls";

export const useSurcharges = () => {
  const tableColumns = () => [
    createColumn("service_name", true, "Service Name"),
    createColumn("invoice_number", true, "Invoice Number"),
    createColumn("applied_type", true, "Applied Type"),
    createColumn("amount", true, "Amount"),
    createColumn("status", true, "Status"),
    createColumn("surcharge_timer", true, "Surcharge Timer"),
    createColumn("active", true, "Active"),
    createColumn("created_by", true, "Created By"),
    createColumn("created_at", true, "Created At"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data.map((item: any) => {
      return {
        ...item,
        active: <BooleanTags status={item?.active} />,
        amount: numberFormat(item?.amount),
        created_at: formatDate(item?.created_at),
        status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
        actions: (
          <FormActions
            actions={[createViewAction(URL_CONFIGURABLES, item?.id)]}
          />
        ),
      };
    });
  };

  return {
    tableColumns,
    tableData,
  };
};
